export const SELECT_DATAS_REQUEST = "SELECT_DATAS_REQUEST";
export const SELECT_DATAS_SUCCESS = "SELECT_DATAS_SUCCESS";
export const SELECT_DATAS_FAIL = "SELECT_DATAS_FAIL";
